// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SYC8","colMin":"styles_colMin__2dGW7"};